import { FC, useCallback } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';

import { AuthRoutePath } from '../modules/auth';
import { DashboardNavBar, Splash } from '../shared/Components';
import { RoutePropsExtended } from '../types';
import { useFirebaseAuth } from '../context/FirebaseContextProvider';

const PrivateRoute: FC<RoutePropsExtended> = ({ component: Component, noNavBar, ...rest }) => {
  const user = useFirebaseAuth();
  const renderRoute = useCallback(
    (props: RouteComponentProps) => {
      const RouteComponent = Component as React.ComponentType<RouteComponentProps>;
      if (user) {
        return !noNavBar ? (
          <DashboardNavBar>
            <RouteComponent {...props} />
          </DashboardNavBar>
        ) : (
          <RouteComponent {...props} />
        );
      } else {
        const to = {
          pathname: `/${AuthRoutePath.Login}`,
          state: {
            from: props.location,
            user,
          },
        };

        return <Redirect to={to} />;
      }
    },
    [Component, noNavBar, user],
  );

  return user === undefined ? <Splash /> : <Route {...rest} render={renderRoute} />;
};

export default PrivateRoute;
